/* eslint-disable multiline-ternary */
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Container as CustomContainer } from '../../base/Grid';
import colors from '../../theme/colors';

export const Container = styled(CustomContainer)`
  z-index: 1;
  color: #ffffff;
`;

export const Section = styled.section`
  ${({ theme, styles }) => {
    const desktop = theme.useMediaQuery(theme.breakpoints.up('medium'));
    return css`
      overflow: hidden; /* for bg blur-up */
      height: ${rem('450px')};
      min-height: ${rem('450px')};
      padding-top: 0; /* for bg blur-up // overwrite global section padding */
      padding-bottom: 0; /* for bg blur-up // overwrite global section padding */

      position: relative;
      align-items: center;
      background-color: ${colors.neutral.white};
      color: #4a4a4a;
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      text-align: center;
      padding: 0px;
      ${desktop && css`
        height: ${rem('400px')};
        max-height: ${rem('400px')};
      `}

      /* Apply any extended or override styles passed in */
      ${styles}
    `;
  }}
`;

export const BackgroundContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #667785 no-repeat scroll 50% 20%;
  background-image: url(${props => (props.loading ? props.lowResImage : props.highResImage)});
  background-position-y: 0%;
  background-size: cover;
  transform: scale(1);

  ${({ loading }) => (!loading
    ? css`
        -webkit-animation: sharpenBg 1s both;
        animation: sharpenBg 1s both;
        @keyframes sharpenBg {
          0% {
            // box-shadow: inset 0 0 200px $color-neutral-black;
            // transform: scale(1.1);
            -webkit-filter: blur(rem-calc(20px));
            filter: blur(rem-calc(20px));
          }
          100% {
            // box-shadow: inset 0 0 0 $color-neutral-black;
            // transform: scale(1.0);
            -webkit-filter: blur(0);
            filter: blur(0);
          }
        `
    : '')}

    /* Apply any extended or override styles passed in */
    ${({ styles }) => css`
      ${styles}
    `
}
`;
